import React from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'gatsby';
import Layout from '../components/Layout';
import Header from '../components/help-hub/Header';
import MainContent from '../components/help-hub/MainContent';
import styled from 'styled-components';

export class HelpHubPageTemplate extends React.Component {
  constructor(props) {
    super();
    this.page = props.page;
  }

  render() {
    const videos = this.page.frontmatter.videos || [];

    return (
      <PageWrapper>
        <Header
          title={this.page.frontmatter.title}
          description={this.page.frontmatter.description}
        />
        <MainContent videos={videos} />
      </PageWrapper>
    );
  }
}

const HelpHubPage = ({ data }) => {
  const { markdownRemark: page } = data;
  const {
    frontmatter: {
      seo: { browserTitle, description: seoDescription },
    },
  } = page;

  return (
    <Layout customTitle={browserTitle} customDescription={seoDescription}>
      <HelpHubPageTemplate page={{ ...page, bodyIsMarkdown: true }} />
    </Layout>
  );
};

HelpHubPage.propTypes = {
  data: PropTypes.object.isRequired,
};

export default HelpHubPage;

export const helpHubPageQuery = graphql`
  query HelpHubPage {
    markdownRemark(frontmatter: { templateKey: { eq: "help-hub-page" } }) {
      frontmatter {
        title
        description
        videos {
          title
          description
          loomId
        }
        seo {
          browserTitle
          description
        }
      }
    }
  }
`;

const PageWrapper = styled.div`
  color: white;
  background-color: #110d11;
  border-bottom: 1px solid #251f26;
`;
